export const data = [
    {
        id: 1,
        name: "Luxurious golden ring",
        searchTerm: "Rings",
        price: 690.99,
        content: "Crafted from high-quality gold, the ring features an intricate design that captivates with its unique beauty. Patterns and details play with the light, giving the ring a distinct sophistication.",
        image: "https://img.freepik.com/free-photo/view-of-luxurious-golden-ring-on-felt-jewelry-display_23-2150329665.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 2,
        name: "Beautiful engagement ring with diamonds",
        searchTerm: "Rings",
        price: 359.99,
        content: "Crafted with meticulous attention to detail, the ring features a dazzling array of diamonds that sparkle and dance with every movement. The central diamond takes center stage, symbolizing the focal point of your journey together.",
        image: "https://img.freepik.com/free-photo/beautiful-engagement-ring-with-diamonds_23-2149509232.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 3,
        name: "Luxurious golden ring",
        searchTerm: "Rings",
        price: 749.99,
        content: "Crafted from the finest gold, the ring exudes a warm and radiant glow. The design is a harmonious blend of classic and contemporary, making it a timeless accessory that transcends trends.",
        image: "https://img.freepik.com/free-photo/view-of-luxurious-golden-ring-on-felt-jewelry-display_23-2150329666.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph" 
    },
    {
        id: 4,
        name: "Luxurious golden ring",
        searchTerm: "Rings",
        price: 729.99,
        content: "The intricate details on the band and setting add a touch of artistry, creating a visual symphony that captures the eye. Each facet reflects the skillful workmanship that went into creating this stunning piece.",
        image: "https://img.freepik.com/free-photo/view-of-luxurious-golden-ring-on-rock-or-concrete-tray_23-2150329705.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 5,
        name: "Aesthetic golden earrings",
        searchTerm: "Earrings",
        price: 459.99,
        content: "Crafted from fine gold, these earrings boast a delicate design that captures attention with its subtle elegance. Their shape and structure harmonize aesthetics with functionality.",
        image: "https://img.freepik.com/free-photo/flat-lay-aesthetic-golden-earrings-arrangement_23-2149846594.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 6,
        name: "Aesthetic golden earrings",
        searchTerm: "Earrings",
        price: 519.99,
        content: "Crafted with precision from fine golden materials, the earrings feature a circular design that exudes sophistication. The timeless appeal of the classical elements intertwines gracefully with the modern aesthetic, making these earrings a versatile and stylish addition to any ensemble.",
        image: "https://img.freepik.com/free-photo/above-view-aesthetic-golden-earrings-arrangement_23-2149846593.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 7,
        name: "Aesthetic golden earrings",
        searchTerm: "Earrings",
        price: 669.99,
        content: "Crafted with meticulous attention to detail, these earrings showcase a perfect blend of modern aesthetics and classic charm, making them a stunning addition to your jewelry collection.",
        image: "https://img.freepik.com/free-photo/flat-lay-aesthetic-golden-earrings-arrangement_23-2149846592.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 8,
        name: "Aesthetic golden earrings",
        searchTerm: "Earrings",
        price: 439.99,
        content: "The delicate golden design captures the essence of sophistication, creating a visual masterpiece that gracefully enhances your overall look. The aesthetic appeal of these earrings is a testament to the careful craftsmanship that went into their creation.",
        image: "https://img.freepik.com/free-photo/high-angle-aesthetic-golden-earrings-arrangement_23-2149846595.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 9,
        name: "Abstract gold chain",
        searchTerm: "Necklaces",
        price: 809.99,
        content: "Crafted from exquisite gold, the chain features an avant-garde and abstract pattern, showcasing creativity and individuality. The unconventional design adds a modern edge to the classic concept of a gold chain, making it a distinctive and eye-catching accessory.",
        image: "https://img.freepik.com/free-photo/abstract-gold-chain-jewellery-presentation_23-2149599103.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 10,
        name: "Abstract gold chain",
        searchTerm: "Necklaces",
        price: 879.99,
        content: "Forged from lustrous gold, the chain's abstract pattern weaves a narrative of creativity and individuality. Its unconventional aesthetic adds a modern twist to the classic concept of a gold chain, creating a captivating accessory that stands out in any crowd.",
        image: "https://img.freepik.com/free-photo/abstract-gold-chain-jewellery-presentation_23-2149599059.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 11,
        name: "Gold and bright chains",
        searchTerm: "Necklaces",
        price: 929.99,
        content: "Each link of these chains shines with the brilliance of gold, exuding luxury and sophistication. Interspersed among the golden links are bright accents, adding a pop of color and energy to the design. The juxtaposition of gold and bright hues creates a dynamic visual effect that captivates the eye.",
        image: "https://img.freepik.com/free-photo/gold-and-bright-chains-still-life_23-2149836443.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 12,
        name: "Luxurious golden necklace",
        searchTerm: "Necklaces",
        price: 1239.99,
        content: "Each link of the golden chain exudes luxury, creating a lustrous and radiant display that gracefully adorns the neckline. The intricate details and craftsmanship showcase the dedication that went into creating this luxurious piece, making it a symbol of refined taste.",
        image: "https://img.freepik.com/free-photo/closeup-shot-of-pieces-of-expensive-golden-jewelry-in-a-store_181624-33812.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 13,
        name: "Golden bracelet",
        searchTerm: "Bracelets",
        price: 549.99,
        content: "Each golden link is a testament to luxury, creating a seamless flow of brilliance that wraps around your wrist in a display of opulence. The craftsmanship, detailed and delicate, elevates this bracelet beyond a mere accessory, turning it into a symbol of tasteful indulgence.",
        image: "https://img.freepik.com/premium-photo/top-view-of-two-golden-bracelets-on-white-dramatic-background-with-copy-space_237502-424.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 14,
        name: "Golden bracelet",
        searchTerm: "Bracelets",
        price: 729.99,
        content: "Crafted with meticulous artistry, this bracelet blends the brilliance of gold with a design that dances between classic elegance and contemporary charm.",
        image: "https://img.freepik.com/premium-photo/gold-bracelet-jewelry-on-white-isolated-background_3544-1157.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 15,
        name: "Luxurious and shiny golden set",
        searchTerm: "Set",
        price: 1249.99,
        content: "This exquisite set, meticulously crafted with the utmost precision, combines the allure of luxury with a dazzling display of shimmering brilliance.",
        image: "https://img.freepik.com/free-photo/luxurious-and-shiny-golden-chain_23-2149635271.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 16,
        name: "Golden diamond set",
        searchTerm: "Set",
        price: 1219.99,
        content: "Each facet of this set reflects the meticulous craftsmanship and attention to detail that went into its creation. The combination of lustrous gold and the scintillating diamonds creates an opulent harmony, turning each piece into a wearable work of art.",
        image: "https://img.freepik.com/premium-photo/golden-diamond-neacklace-and-earrings-on-white-background_93675-153727.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=sph"
    },
    {
        id: 17,
        name: "Luxurious and shiny golden set",
        searchTerm: "Set",
        price: 1149.99,
        content: "Crafted with precision, the golden surfaces of each piece gleam with an irresistible shine, reflecting light in every direction. The set is a testament to the artistry of combining luxury and luminosity in a way that defines elegance.",
        image: "https://img.freepik.com/free-photo/luxurious-and-shiny-golden-chain_23-2149635287.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=ais"
    },
    {
        id: 18,
        name: "Luxurious and shiny golden set",
        searchTerm: "Set",
        price: 1259.99,
        content: "The necklace, a cascade of golden brilliance, graces the neckline with a regal allure. The matching bracelet effortlessly adorns the wrist, while the earrings add a touch of sophistication to frame the face. Together, they create a harmonious and dazzling statement.",
        image: "https://images.unsplash.com/photo-1603298333647-ed142dbbc9d9?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTg1fHxqZXdlbHJ5JTIwc2V0c3xlbnwwfHwwfHx8MA%3D%3D"
    },
    {id: 19,
        name: "Golden bracelet",
        searchTerm: "Bracelets",
        price: 559.99,
        content: "The bracelet features a seamless chain of lustrous golden links, creating a fluid and graceful design that delicately encircles the wrist. Each link reflects the richness of gold, exuding a warm and radiant glow.",
        image: "https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YnJhY2VsZXRzfGVufDB8fDB8fHww"
    },
    {id: 20,
        name: "Golden bracelet",
        searchTerm: "Bracelets",
        price: 639.99,
        content: "A symphony of intricate links forms a radiant chain, each element reflecting the luxurious quality of gold. The bracelet gracefully drapes around the wrist, creating a statement piece that effortlessly elevates any ensemble.",
        image: "https://img.freepik.com/free-photo/vertical-closeup-shot-of-a-female-wearing-a-golden-bracelet_181624-15771.jpg?size=626&ext=jpg&ga=GA1.1.1202550608.1704880132&semt=ais"
    }
    
]